export const config = {
  hummBackendAppURL:process.env.REACT_APP_BACKEND
 };
 export default config;
